export default class TicketTabs {
    constructor() {
        document.querySelectorAll(".js-ticket-tabs").forEach((group) => this.initGroup(group));
    }

    initGroup(group) {
        const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        const activate = (nextTab, moveFocus = false) => {
            tabs.forEach((tab) => {
                const selected = tab === nextTab;
                const panel = document.getElementById(tab.getAttribute("aria-controls"));

                tab.classList.toggle("-active", selected);
                tab.setAttribute("aria-selected", String(selected));
                tab.tabIndex = selected ? 0 : -1;

                if (panel) {
                    panel.hidden = !selected;
                    panel.classList.toggle("-active", selected);
                }
            });

            if (moveFocus) nextTab.focus();

            const panel = document.getElementById(nextTab.getAttribute("aria-controls"));
            panel?.querySelectorAll(".swiper").forEach((slider) => slider.swiper?.update());

            window.scrollFunc?.refresh();
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => activate(tab));
            tab.addEventListener("keydown", (event) => {
                if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

                event.preventDefault();
                const direction = event.key === "ArrowRight" ? 1 : -1;
                const nextIndex = (index + direction + tabs.length) % tabs.length;
                activate(tabs[nextIndex], true);
            });
        });
    }
}
